// extracted by mini-css-extract-plugin
export default {"number":"BigNumber_number__+vjE0","title":"BigNumber_title__DF4wG","movein":"BigNumber_movein__8W4It"};